














import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class YaTidak extends Vue {
  @Prop() value!: string | null;
}
